import AllTradesmen from './AllTradesmen';
import TradesmanUserDetails from './TradesmenUserDetails';
import Performance from './Performance';

import './styles.scss';

const exports = { AllTradesmen, TradesmanUserDetails, Performance };

export default exports;
